import { ErrorType, ErrorLocationType } from "@/utilities/system/enums/Enums";
import router from "@/router";
import { GeneralResponse } from "@/models/system/api/Responses";
import { useSystemStore } from "@/stores/system/SystemStore";
import { $t } from "@/utilities/system/i18n/config";
import {isDev} from "@/AppConfig";

class ErrorHandler {

    public handleError(error:GeneralResponse, errorLocation:ErrorLocationType){
        // @ts-expect-error
        const statusCode = error.statusCode ?? error.StatusCode;
        const isResponseError = statusCode === 400 || statusCode > 999;

        const errorType = isResponseError ? ErrorType.warning : ErrorType.error;

        let notify;
        if(isResponseError){
            notify = this.reactoToStatusCode(statusCode);

            if(notify){
                this.notifyFailedCommunication(errorType, error.statusDescription, errorLocation);
            }
        }
        else{
            notify = this.reactoToStatusCode(statusCode);

            if(notify){
                // @ts-expect-error
                this.notifyFailedCommunication(errorType, $t("error.status.general", {message:error.statusDescription ?? error.StatusDescription}), errorLocation);
            }
        }
    }


    /*  PRIVATE  */


    private notifyFailedCommunication(type:ErrorType, text:string, errorLocation:ErrorLocationType) {
        const systemStore = useSystemStore();

        systemStore.gridDataIsLoading = false;

        systemStore.error = {
            location: errorLocation,
            text: text,
            type: type,
        };
    }


    /*
        handles special status codes and what to do when encountering them
        returns if the calling method needs to notify the user
    */
    private reactoToStatusCode(status:number):boolean {
        switch (status) {
            case 401:{
                this.notifyFailedCommunication(ErrorType.error, $t('global.noValidToken'), ErrorLocationType.login);
                if (!isDev) router.replace('/login').catch(error => {console.log("routing to login page failed: ", error);})

                return false;
            }

            default:{
                return true;
            }
        }
    }
}

export default new ErrorHandler();
